(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('.slideout').each(function () {
		var slideout = $(this);
		var trigger = slideout.find('.slideout__trigger');
		var content = slideout.find('.slideout__content');
		var closer = slideout.find('.slideout__close');
		var otherLinks = $('a[href="' + trigger.attr('href') + '"]:not(.slideout__trigger)');

		// Open slideout when clicking any link pointing to it
		otherLinks.on('click', function (e) {
			e.preventDefault();

			trigger.click();
		});

		// Open on trigger click
		trigger.on('click', function (e) {
			e.preventDefault();

			// If this trigger has a data-popup attribute - open that popup instead in low res
			var popup = trigger.attr('data-popup');

			if (popup && $(window).width() < 760) {
				$('<a href="#contact-popup" data-lightbox></a>').appendTo(document.body).click().remove();
			}
			else {
				slideout.toggleClass('open');
			}
		});

		// Close on "Close" button click
		closer.on('click', function (e) {
			e.preventDefault();

			slideout.removeClass('open');
		});

		// Close on outside click
		slideout.on('click', function (e) {
			if (this === e.target || content[0] == e.target) { // Clicking the content div directly also counts as an outside click
				slideout.removeClass('open');
			}
		});
	});
})();
